import React from "react";
import "./css/About.css";

export const About = () => {
	return (
		<div className="about-container">
			Welcome! I'm Athena Savage, a software engineer, single parent, and
			technology enthusiast with a strong background in web development and
			software engineering. I'm currently pursuing my BA in Software Engineering
			while working on various innovative projects. My diverse interests like
			traveling, reading, cooking, and architecture have shaped my unique
			perspective, making me a versatile team member. Being a single parent has
			honed my organizational and time-management skills, crucial in the tech
			industry. I invite you to explore my portfolio and learn about my projects
			and accomplishments. I'm eager to collaborate with like-minded individuals
			and teams who share my passion for technology. Thank you for visiting my
			website, and feel free to get in touch for any inquiries or potential
			collaborations.
		</div>
	);
};
